const es = {
  'home.title': 'Recibir SMS Online | 18+ Países | 100% Gratis & sin Anuncios',
  'home.description':
    'La mayor colección de números de numero temporales en Internet. 18+ Países, 100+ números. 100% gratis, sin Anuncios, no hay Registro.',
  allnumbers: 'Todos los numeros',
  home: 'Página de inicio',
  about: 'Sobre',
  privacypolicy: 'Política de privacidad',
  'home.header': 'Recibir SMS Online Gratis',
  'home.subheader': 'La mayor colección de números de numero temporales en Internet. 100% gratis, sin Anuncios, no hay Registro.',
  browsenumbercountry: 'Buscar números por país:',
  'home.noaccount': 'No se requiere cuenta - todos nuestros mensajes de texto están disponibles sin registro',
  'home.100free': 'y 100% gratis!',
  howtogetstarted: 'Cómo empezar',
  'home.how1': 'Seleccione el país y elija un número de teléfono disponible',
  'home.how2': 'Envía un SMS al número de teléfono seleccionado',
  'home.how3': 'Presione actualizar mensajes y espere a que su respuesta aparezca en la página',
  'home.how4': 'Todos los mensajes son públicos, así que evite enviar información personal.',
  'home.pointsubtitle': 'Caso de uso múltiple',
  'home.pointtitle': 'Números de teléfono desechables',
  'home.verification': 'Verificación',
  'home.freetemporary': 'Números temporales gratuitos',
  'home.internationalnumbers': 'Números de teléfono internacionales',
  'home.point1':
    '¿Necesitas más de una cuenta? Utilice nuestros números para la verificación de mensajes de texto para uber, wechat, whatsapp, netflix y más.',
  'home.point2': '¿Quieres ver netflix extranjero? Tenemos números móviles de más de 10 países diferentes',
  'home.point3': 'Todos nuestros números virtuales son 100% gratuitos.',
  'country.title': ({ country }) => `Recibir SMS Online ${country} | 100% Gratis & sin Anuncios | 18+ Países`,
  'country.description': ({ country }) => `Números de teléfono temporales del ${country}. 100% gratis, sin Anuncios, no hay Registro.`,
  'country.header': ({ country }) => `Recibir SMS Online ${country}`,
  'country.subheader': ({ country }) => `Números de teléfono temporales del ${country}. 100% gratis, sin Anuncios, no hay Registro.`,
  selectanumber: `Seleccione un número a continuación:`,
  lastmessage: ({ minute }) => `Último mensaje: hace ${minute} minutos`,
  upvotes: ({ upvote }) => `${upvote}% votos a favor`,
  'country.how1': 'Seleccione un número de teléfono arriba y envíe un SMS al número',
  'country.findother': 'Encuentra números en otros países:',
  'telephone.title': ({ country, telephone }) => `+${telephone} Recibir SMS Online | ${country} | 100% Gratis & sin Anuncios`,
  'telephone.description': 'La mayor colección de números de numero temporales en Internet. 100% gratis, sin Anuncios, no hay Registro.',
  'telephone.header': 'Recibir SMS Online Gratis',
  'telephone.noText': 'Aún no se han recibido mensajes de texto. Presiona actualizar para ver los últimos mensajes.',
  'telephone.subheader':
    'Todos los mensajes de texto enviados a este número de teléfono aparecerán a continuación. Presiona actualizar para ver los últimos mensajes.',
  refreshmessages: 'Actualizar Mensajes',
  'telephone.mostRecent': 'Mensajes de texto más recientes',
  change: 'Cambiar',
  'telephone.change': 'Cambiar Número de Teléfono',
  minutesago: 'hace minutos',
  hoursago: 'horas atras',
  otherCountryNumbers: ({ country }) => `Otros números de ${country}:`
}

const esCountry = {
  'united-kingdom': 'reino-unido',
  germany: 'alemania',
  'united-states': 'estados-unidos',
  france: 'francia',
  russia: 'rusia',
  mauritius: 'mauricio',
  poland: 'polonia',
  netherlands: 'paises-bajos',
  india: 'india',
  israel: 'israel',
  kazakhstan: 'kazajstan',
  mexico: 'mexico',
  indonesia: 'indonesia',
  portugal: 'portugal',
  sweden: 'suecia',
  canada: 'canada',
  'hong-kong': 'hong-kong',
  china: 'china',
  morocco: 'marruecos',
  ukraine: 'ucrania',
  romania: 'rumania',
  brazil: 'brasil',
  nigeria: 'nigeria',
  ireland: 'irlanda',
  spain: 'españa',
  'czech-republic': 'republica-checa',
  thailand: 'tailandia',
  italy: 'italia',
  japan: 'japón',
  austria: 'austria',
  taiwan: 'taiwán',
  singapore: 'singapur',
  'south-korea': 'corea del sur',
  finland: 'finlandia'
}

const zhcn = {
  'home.title': '在线接收短信 | 18+ 个国家 | 100% 免费且无广告',
  'home.description': '互联网上最大的临时电话号码集合。 18 多个国家/地区，100 多个号码。 100% 免费，无广告，无需注册',
  allnumbers: '所有号码',
  home: '主页',
  about: '关于',
  privacypolicy: '隐私政策',
  'home.header': '免费在线接收短信',
  'home.subheader': '互联网上最大的临时电话号码集合。 18 多个国家/地区，100 多个号码。 100% 免费，无广告，无需注册',
  browsenumbercountry: '按国家浏览号码：',
  'home.noaccount': '无需帐户 - 我们所有的手机号码无需注册即可使用并且 100% 免费',
  'home.100free': '并且 100% 免费',
  howtogetstarted: '如何开始',
  'home.how1': '选择国家并选择一个可用的电话号码',
  'home.how2': '向选定的电话号码发送短信',
  'home.how3': '按刷新消息并等待您的回复出现在页面上',
  'home.how4': '所有消息都是公开的，因此请避免发送个人信息',
  'home.pointsubtitle': '多个用例',
  'home.pointtitle': '一次性电话号码',
  'home.verification': '确认',
  'home.freetemporary': '免费临时号码',
  'home.internationalnumbers': '国际电话号码',
  'home.point1': '需要多个帐户？使用我们的号码对 uber、wechat、whatsapp、netflix 等进行文本验证。',
  'home.point2': '想看国外的Netflix？我们有来自 10 多个不同国家的手机号码。',
  'home.point3': '我们所有的虚拟号码都是 100% 免费的',
  'country.title': ({ country }) => `在线接收${country}短信 | 100% 免费且无广告 | 18+ 个国家`,
  'country.description': ({ country }) => `${country} 临时号码. 100% 免费，无广告，无需注册`,
  'country.header': ({ country }) => `在线接收${country}短信`,
  'country.subheader': ({ country }) => `${country} 临时号码. 100% 免费，无广告，无需注册`,
  selectanumber: `在下面选择一个数字:`,
  lastmessage: ({ minute }) => `最后一条消息: ${minute} 分钟前`,
  'country.how1': '在上方选择一个电话号码并向该号码发送短信',
  'country.findother': '查找其他国家/地区的号码：',
  'telephone.title': ({ country, telephone }) => `+${telephone} 在线接收短信 | ${country} | 100% 免费且无广告`,
  'telephone.description': '互联网上最大的临时电话号码集合。 15 多个国家，100 多个号码。 100% 免费，无广告，无需注册。',
  'telephone.header': '免费接收短信',
  'telephone.noText': '还没有收到短信。按刷新查看最新消息',
  'telephone.subheader': '发送到此电话号码的任何文本都将显示在下方。按刷新查看最新消息',
  refreshmessages: '刷新消息',
  'telephone.mostRecent': '最近的短信',
  change: '改变',
  'telephone.change': '更改电话号码',
  minutesago: '几分钟前',
  hoursago: '小时',
  otherCountryNumbers: ({ country }) => `其他${country}号码:`,
  upvotes: ({ upvote }) => `${upvote}% 赞成票`
}

const zhcnCountry = {
  'united-kingdom': '英国',
  germany: '德国',
  'united-states': '美国',
  france: '法国',
  russia: '俄罗斯',
  mauritius: '毛里求斯',
  poland: '波兰',
  netherlands: '荷兰',
  india: '印度',
  israel: '以色列',
  kazakhstan: '哈萨克斯坦',
  mexico: '墨西哥',
  indonesia: '印度尼西亚',
  portugal: '葡萄牙',
  sweden: '瑞典',
  canada: '加拿大',
  'hong-kong': '香港',
  china: '中国',
  morocco: '摩洛哥',
  ukraine: '乌克兰',
  romania: '罗马尼亚',
  brazil: '巴西',
  nigeria: '尼日利亚',
  spain: '西班牙',
  ireland: '爱尔兰',
  'czech-republic': '捷克共和国',
  thailand: '泰国',
  italy: '意大利',
  japan: '日本',
  austria: '奥地利',
  taiwan: '台湾',
  singapore: '新加坡',
  'south-korea': '韩国',
  finland: '芬兰'
}

module.exports = {
  translate: (defaultString, tag, lang, variables) => {
    if (lang === 'zh-cn') {
      const translation = zhcn[tag]
      if (!translation) {
        console.log('NO TRANSLATION', defaultString)
        return defaultString
      }
      if (typeof translation === 'string') {
        return translation
      }
      return translation(variables)
    }
    if (lang === 'es') {
      const translation = es[tag]
      if (!translation) {
        console.log('NO TRANSLATION', defaultString)
        return defaultString
      }
      if (typeof translation === 'string') {
        return translation
      }
      return translation(variables)
    }
    return defaultString
  },
  countryTranslate: (country, lang) => {
    if (lang === 'zh-cn') {
      return zhcnCountry[country]
    }
    if (lang === 'es') {
      return esCountry[country]
    }
    return country
  },
  activeCountries: []
}

// russia
// mauritius
// poland
// netherlands
// india
// israel
// kazakhstan
// Mexico
// Indonesia
// Portugal
// sweden
// Canada
// hong kong
// china
// morocco
// ukraine
// romania
// brazil
// nigeria
// ireland
// czech republic
